export default __webpack_public_path__ + "static/media/What we do-eachpage-Digital Product_Experience and Design.90f8c9ac.png";